export const FACEBOOK = 'facebook'
export const META = 'meta'
export const GOOGLE = 'google'
export const MICROSOFT = 'microsoft'

export const PLATFORMS = {
  MICROSOFT: 'microsoft',
  META: 'meta',
  GOOGLE: 'google',
  WORDPRESS: 'wordpress',
} as const

export type Platforms = (typeof PLATFORMS)[keyof typeof PLATFORMS]
export type ServersidePlatformsNames = 'Microsoft' | 'Meta' | 'Google'
